var character = "Characters";
var copied = "Copied";
var copy = "Copy";
var insert = "Insert";
var loading = "Naglo-load";
var orCopyLink = "Or copy link";
var submit = "Submit";
var tlTranslations = {
	"actionPopover.delete": "Delete",
	"actionPopover.deleteNotification": "Delete this notification",
	"actionPopover.edit": "Edit",
	"actionPopover.inviteShareCommunity": "Invite / Share community",
	"actionPopover.joinCommunity": "Join Community",
	"actionPopover.leaveCommunit": "Leave Community",
	"actionPopover.leaveCommunity": "Leave Community",
	"actionPopover.leaveCommunity.accept": "Leave",
	"actionPopover.leaveCommunity.cancel": "Cancel",
	"actionPopover.leaveCommunity.description": "Are you sure you want to leave this community?",
	"actionPopover.leaveCommunity.title": "Leave Community",
	"actionPopover.report": "Report",
	"actionPopover.turnOffNotification": "Turn off notification",
	"actionPopover.turnOffNotificationAbout": "Turn off notification about {label}",
	"actionPopover.turnOnNotification": "Turn on notification",
	"adBanner.title": "advertisement",
	"admin.comments": "Comments",
	"admin.communities": "Communities",
	"admin.community": "Community",
	"article.shareOn": "Share on",
	"articleAuthor.title.expert": "Expertly reviewed by",
	"articleAuthor.title.fact-check": "Sinuri ang mga impormasyon ni {name}",
	"articleAuthor.title.medical": "Medically reviewed by",
	"articleAuthor.title.written-by": "Written by",
	"articlePage.articleReviewerBy": "Narebyung medikal ni {name}",
	"articlePage.readMore": "Magbasa pa",
	"articlePage.showLess": "Magpakita ng mas kaunti",
	"babyGrowth.alert.bmi": "Walang BMI measurements na ipapakita para kay {name} sa hanay ng data ng WHO na 0 hanggang 5 taon. Gumamit ng <a>BMI calculator tool</a> higit sa 5 taong gulang",
	"babyGrowth.alert.head": "Walang head circumference na ipapakita para kay {name} sa hanay ng data ng WHO na 0 hanggang 5 taon",
	"babyGrowth.alert.weight": "Walang mga sukat ng timbang na ipapakita para kay {name} sa hanay ng data ng WHO na 0 hanggang 10 taon",
	"babyGrowth.babyInfo": "Impormasyon ng Sanggol",
	"babyGrowth.chartTitle": "WHO - {name} Growth Chart",
	"babyGrowth.chartTitle.noName": "Growth chart ng iyong baby",
	"babyGrowth.cm": "cm",
	"babyGrowth.drawer.addMeasurement": "I-add ang sukat",
	"babyGrowth.drawer.createBaby": "Gumawa ng baby propayl",
	"babyGrowth.drawer.switchProfile": "I-switch ang propayl",
	"babyGrowth.emptyName": "your baby",
	"babyGrowth.error.atLeastOneOf": "Must have at least one of these fields: Weight, Height, Head Circumference (Head)",
	"babyGrowth.error.birthdayRequired": "Birthday is required",
	"babyGrowth.error.invalidAge": "The measurements exceed the age.",
	"babyGrowth.error.invalidMeasurementDate": "Measurement day is not valid.",
	"babyGrowth.error.invalidValue": "Please input a valid value",
	"babyGrowth.error.measurementDateLowerThanBirthday": "The date entered is before your child's birthday",
	"babyGrowth.error.outOfRange": "The measurements exceed the WHO's data range.",
	"babyGrowth.error.title": "Invalid data",
	"babyGrowth.head": "Ulo",
	"babyGrowth.headCircumference": "Circumference ng ulo",
	"babyGrowth.height": "Taas",
	"babyGrowth.input.babyName": "Child’s name",
	"babyGrowth.input.birthday": "Baby's birthday",
	"babyGrowth.input.bmi": "Body Mass",
	"babyGrowth.input.bodyMass": "Body Mass",
	"babyGrowth.input.checkSubmit": "Track your child's growth",
	"babyGrowth.input.measurementDate": "Measurement Date",
	"babyGrowth.input.submit": "Track your child's growth",
	"babyGrowth.kg": "kg",
	"babyGrowth.kg.m2": "kg/m2",
	"babyGrowth.monthly": "Monthly",
	"babyGrowth.nickname": "Nickname",
	"babyGrowth.optional": "(optional)",
	"babyGrowth.pageTitle": "Your child's growth results",
	"babyGrowth.percentiles": "Percentiles",
	"babyGrowth.placeholder.babyName": "Add child's name",
	"babyGrowth.popup.heading": "Baby's Profile",
	"babyGrowth.reCalculate": "Muling kalkulahin",
	"babyGrowth.record": "Records",
	"babyGrowth.save": "View Growth Tracker",
	"babyGrowth.save.loggedIn": "Tingnan ang growth tracker ni {name}",
	"babyGrowth.weekly": "Weekly",
	"babyGrowth.weight": "Timbang",
	"babyGrowth.xLabel": "Age ({recurrence})",
	"babyGrowth.yearly": "Yearly",
	"babyPoop.findOut": "Alamin",
	"babyPoopTool.name": "Baby Poop",
	"babyVaccine.banner.readmore": "Magbasa pa ",
	"babyVaccine.detail.benifit": "Mga Benepisyo",
	"babyVaccine.detail.contraindication": "Mga Kontraindikasyon",
	"babyVaccine.detail.definition": "Kahulugan",
	"babyVaccine.detail.relatedArticles": "Mga Kaugnay na Artikulo",
	"babyVaccine.immunization.vaccineName": "Pangalan ng bakuna",
	"babyVaccine.immunization.warning": "Ang immunization static ay madaling basahing dahil kamukha rin ito ng iyong baby vaccination timelines",
	"babyVaccine.popup.button": "Create a new profile",
	"babyVaccine.popup.button.submit": "I-save",
	"babyVaccine.popup.checkbox.suggestedDate": "Pumili ng petsa o huwag baguhin ang iminungkahi sa baba.",
	"babyVaccine.popup.confirm.close": "Baguhin ang petsa",
	"babyVaccine.popup.confirm.description": "Ang iyong baby ay binakunahan nito noong {date}",
	"babyVaccine.popup.confirm.ok": "Kumpirmahin",
	"babyVaccine.popup.confirm.title": "Petsa ng bakuna",
	"babyVaccine.popup.input.suggestedDate": "Hindi ko maalala/I-set bilang suggested date",
	"babyVaccine.popup.label.doses": "Mga dose",
	"babyVaccine.popup.tab.benefits": "Mga Benepisyo",
	"babyVaccine.popup.tab.contraindication": "Contraindication",
	"babyVaccine.popup.tab.detail": "Detalye",
	"babyVaccine.popup.tab.schedule": "Pag-track",
	"babyVaccine.popup.title": "Impormasyon sa Bakuna",
	"babyVaccine.status.all": "Lahat",
	"babyVaccine.status.missed": "Na-miss na bakuna",
	"babyVaccine.status.next": "Next",
	"babyVaccine.status.upcoming": "Paparating",
	"babyVaccine.status.vaccinated": "Bakunado",
	"babyVaccine.timeline.antigen": "Antigen:",
	"babyVaccine.timeline.atBirth": "\nsa kapanganakan",
	"babyVaccine.timeline.total": "Total: {number} Dose(s)",
	"babyVaccine.timeline.totalNext": "Susunod na {number} Dose(s)",
	"babyVaccine.timeline.totalPast": "Nakaraang {number} Dose(s)",
	"babyVaccine.vaccineCard.injected": "Injected",
	"babyVaccine.vaccineCard.markAsInjected": "Markahan na injected",
	"babyVaccine.vaccineInfo.dose": "Dose: {ordinal}/{total}",
	"babyVaccine.vaccineInfo.injectedDate": "Petsa ng pag-inject: {date}",
	"babyVaccine.vaccineInfo.mandatory": "Mandatory",
	"babyVaccine.vaccineInfo.optional": "Opsyonal",
	"babyVaccine.vaccineInfo.suggested": "Iminungkahing petsa: {date}",
	"babyVaccineTool.heading": "Baby Vaccine Scheduler",
	"bmi.ageInput": "Ilan taong ka na?",
	"bmi.ageInput.desc": "(mga taon)",
	"bmi.ageInput.error": "Mangyaring ilagay ang wastong edad",
	"bmi.heading": "BMI Calculator",
	"bmi.heightInput": "Gaano ka kataas?",
	"bmi.heightInput.desc": "(cm)",
	"bmi.heightInput.error": "Mangyaring ilagay ang wastong taas",
	"bmi.objective": "Layunin",
	"bmi.objective.gainWeight": "Bumuo ng muscle",
	"bmi.objective.loseWeight": "Mawalan ng taba",
	"bmi.objective.maintainWeight": "Panatilihin ang timbang",
	"bmi.result.healthy": "Malusog",
	"bmi.result.overweight": "Sobra sa timbang",
	"bmi.result.underweight": "Kulang sa timbang",
	"bmi.selectGender": "Ano ang iyong  kasarian?",
	"bmi.submit": "Kalkulahin",
	"bmi.weightInput": "Gaano ka kabigat?",
	"bmi.weightInput.desc": "(kg)",
	"bmi.weightInput.error": "Mangyaring ilagay ang wastong timbang",
	"bmr.heading": "BMR Calculator",
	"booking.searchBar.allLocations": "Lahat ng Lugar",
	"booking.searchBar.allSpecialties": "Lahat ng mga Espesyalidad",
	"booking.searchBar.currentLocation": "Current location",
	"booking.searchBar.grantLocation": "Please grant location permission to search by current location",
	"booking.searchBar.locationPlaceholder": "Enter city",
	"booking.searchBar.noResults": "No Results",
	"booking.searchBar.placeholder.doctor": "Search by doctor name",
	"booking.searchBar.placeholder.hospital": "Search by hospital name",
	"booking.searchBar.placeholder.service": "Search by service",
	"booking.searchBar.placeholder.specialty": "Search by specialty",
	"booking.searchBar.popularKey": "Sikat na Key-search",
	"booking.searchBar.searchButton": "Search",
	"booking.searchBar.searchInput.placeholder": "Search by Specialty or Clinic...",
	"booking.searchBar.useCurrentLocation": "Use my current location",
	"booking.searchBar.viewAll": "Tingnan Lahat",
	"booking.searchPopup.doctors": "Doctors",
	"booking.searchPopup.hospitals": "Hospitals & Clinics",
	"booking.searchPopup.searchIn.doctors": "Search \"{name}\" in Doctors",
	"booking.searchPopup.searchIn.hospitals": "Search \"{name}\" in Hospitals",
	"booking.searchPopup.searchIn.services": "See \"{name}\" in Services",
	"booking.searchPopup.searchIn.specialties": "Search \"{name}\" in Specialties",
	"booking.searchPopup.seeAll": "See All",
	"booking.searchPopup.seeLessSpecialties": "See less specialties",
	"booking.searchPopup.seeMoreSpecialties": "See more specialties",
	"booking.searchPopup.services": "Services",
	"booking.searchPopup.specialties": "Specialties",
	"booking.searchResult.description": "{search_type} sa {search_location}\n",
	"bottomBar.share": "Share",
	"cardAuthor.admin": "Admin",
	"cardAuthor.ambassador": "Ambassador",
	"cardAuthor.expert": "Expert",
	"cardAuthor.guide": "Guide",
	"cardAuthor.influencer": "Influencer",
	"cardAuthor.localAdmin": "Local Admin",
	"cardAuthor.moderator": "Moderator",
	"cardAuthor.sponsor": "Sponsor",
	"cardPost.anonymous": "Anonymous",
	"cardPost.option.anonymous": "Anonymous",
	"cardPost.public": "Pampubliko",
	"cardReactions.comment": "Comment",
	"cardReactions.like": "Like",
	"cardReactions.repliesCount": "mga reply",
	"cardReactions.reply": "Reply",
	"cardReactions.save": "Save",
	"cardReactions.unSave": "Unsave",
	"cardReply.disclaimer": "<strong>Disclaimer:</strong> The content is furnished relying on authenticated information sources.",
	"cardReply.endorse": "Endorse",
	"cardReply.opposePopup.content": "Can you please provide the reasons for refuting this answer?",
	"cardReply.opposePopup.submit": "Submit",
	"cardReply.pppose": "Refute",
	"cardReply.recommentCategories.heading": "Related content",
	"cardReply.source": "Sources",
	"cardReply.verifyBy": "Medically reviewed by {name}",
	"careBooking.bookAnAppointment": "Mag-book ng appointment",
	"categoryPage.info.reviewed": "Narebyung medikal ni",
	"categoryPage.onDate": "sa {date}",
	character: character,
	"chatbot.with.me": "Chat with me",
	"childCard.age.months": "{month} buwan",
	"childCard.age.oneMonth": "1 buwan",
	"childCard.age.oneWeek": "1 linggo",
	"childCard.age.oneYear": "1 taon",
	"childCard.age.oneYearMonth": "1 taon {month} buwan",
	"childCard.age.oneYearOneMonth": "1 taon at 1 buwan",
	"childCard.age.week": "{weeks} linggo",
	"childCard.age.yearMonth": "{year} taon {month} buwan",
	"childCard.age.yearNoMonth": "{year} taon",
	"childCard.age.yearOneMonth": "{year} taon at 1 buwan",
	"childCard.boy": "Boy",
	"childCard.girl": "Girl",
	"childCard.menu.add": "Mag-add ng baby propayl",
	"childCard.menu.edit": "I-edit ang {name}’s ng propayl",
	"childCard.menu.remove": "Alisin ang {name}’s ng propayl",
	"childCard.menu.switch": "I-switch sa propayl ng baby",
	"childCard.noName": "Pangalan ng Baby",
	"choicePopover.ambassadorPosts": "Ambassador posts",
	"choicePopover.expertPosts": "Expert posts",
	"choicePopover.lastestPost": "Latest posts",
	"choicePopover.latest": "Latest",
	"choicePopover.newest": "Newest",
	"choicePopover.oldest": "Oldest",
	"choicePopover.popular": "Popular",
	"choicePopover.popularPost": "Popular posts",
	"choicePopover.sort": "Sort",
	"choose.community": "Choose your community",
	"choose.other.community": "Choose another community",
	"chooseBaby.button": "Tingnan ang iyong Baby Growth Chart",
	"chooseBaby.new": "o mag-add ng bagong baby profile",
	"chooseBaby.placeholder": "Pahingi ng pangalan ng baby",
	"chooseBaby.title": "Pumili ng Baby Profile",
	"comment.count": "{count} comments",
	"comment.now": "Comment now",
	"comment.seeMoreComments": "See {count} more comments",
	"comment.seeMoreReplies": "See {count} more replies",
	"commentPopup.warning.newPost": "Ang iyong comment ay makikita ng lahat.",
	"common.playing": "Playing ...",
	"common.profileNavigator.newsletterSubscription": "Newsletter Subscription",
	"common.sponsoredBy": "Ini-sponsor ng",
	"common.totalView": "{number} na pagtingin",
	"community.choose": "Choose a community",
	"community.notification.joined": "You joined {name} community",
	"community.notification.left": "You left {name} community",
	copied: copied,
	copy: copy,
	"createPost.askDoctor": "Magtanong sa doktor",
	"createPost.askDoctor.description": "Humingi ng payo mula sa aming mga eksperto",
	"createPost.askDoctorChoice.no": "No",
	"createPost.askDoctorChoice.yes": "Yes",
	"createPost.communityAndTopic": "Komunidad & Paksa",
	"createPost.message.askDoctorRequire": "Would you like to ask a question to our doctor?",
	"createPost.message.askDoctorRequireMess": "Pakipili ang isang opsyon",
	"createPost.message.lengthDescription": "Ang paglalarawan ay dapat may hindi bababa sa 10 salita",
	"createPost.message.lengthTitle": "The title must be at least 5 words",
	"createPost.message.lengthTitle.characters": "The title must be at least 5 characters long.",
	"createPost.message.photoMaxium": "Maximum na 10 larawan kapag nag-upload ng mga larawan para sa post",
	"createPost.message.photoSize": "Pinapayagan lamang mag-upload ng larawan na may laki <= 10 MB",
	"createPost.message.requiredDescription": "Kailangan ang paglalarawan",
	"createPost.message.requiredTitle": "Kailangan ang pamagat",
	"createPost.message.suggestLoading": "We are suggesting relevant communities for your post",
	"createPost.message.suggestResult": "You can post now! We will continue to find relevant communities right after that",
	"createPost.now": "Post now",
	"createPost.photos": "Mga Larawan",
	"createPost.popup.description": "Description",
	"createPost.popup.guideSelectMonthTopics": "Choose topics about your baby's birth month",
	"createPost.popup.guideSelectTopics": "Choose topics, where to post your articles",
	"createPost.popup.primary": "Tap to select/ unselect topics",
	"createPost.popup.selectMonthTopicBtn": "Select",
	"createPost.popup.specialCharErr": "The title you entered is invalid. Titles must contain letters.\n",
	"createPost.popup.submit": "Post",
	"createPost.popup.success": "New Post Created",
	"createPost.popup.warning": "Select a community to see your following topics",
	"createPost.popup.warningImage": "Maximum 20 images allow, please remove some item below",
	"createPost.popup.wordCount": "{count}/{max} words",
	"createPost.post.askDoctor.description": "Describe symptoms",
	"createPost.post.askDoctor.title": "Symptom name",
	"createPost.post.description": "Post description",
	"createPost.post.title": "Post title",
	"createPost.postAnonymous": "Mag-post anonymously",
	"createPost.title": "Title",
	"createPost.urlText": "Text",
	"createPost.video": "Video",
	"createPost.videoOrLink": "Video o link",
	"dueDatePage.IUI": "Intrauterine insemination (IUI)",
	"dueDatePage.calculationMethod": "Calculation Method",
	"dueDatePage.conceptionDate": "Petsa ng Conception",
	"dueDatePage.date_of_IUI_procedure": "Araw ng IUI procedure",
	"dueDatePage.date_of_ultrasound": "Araw ng Ultrasound",
	"dueDatePage.daysText": "{number} mga araw",
	"dueDatePage.ivf": "IVF",
	"dueDatePage.ivf.transferDate": "Petsa ng Paglipat ng IVF",
	"dueDatePage.ivf.transferDateRadio": "{number}-Araw ng Paglipat",
	"dueDatePage.lastPeriod": "Huling Araw ng Regla",
	"dueDatePage.lastPeriod.calculate": "Kalkulahin",
	"dueDatePage.lastPeriod.lastPeriodLabel": "Ang unang araw ng iyong huling regla",
	"dueDatePage.lastPeriod.periodLengthLabel": "Haba ng Siklo",
	"dueDatePage.ultrasound": "Ultrasound",
	"dueDatePage.ultrasound.tooltip": "Mean sac Diameter (MSD) is less accurate than Crown-Rump Length (CRL) for dating a pregnancy. It is only used in very early pregnancy, between 4 and 6 weeks.",
	"dueDatePage.validation.crl": "The MSD value is invalid. Please enter the CRL metric to continue.",
	"dueDatePage.validation.one_is_required": "Kahit isa ay kinakailangan",
	"dueDatePage.validation.record_not_valid": "Your recorded isn't valid!",
	"editor.addSocialLink.addLink": "Magdagdag",
	"editor.addSocialLink.warningDomain": "Pinapayagan lamang ang mga source mula sa Youtube, Facebook, at Tiktok",
	"expert.content.description": "Propayl ng Eksperto",
	"expert.content.experiences": "Experiences",
	"footer.signUp": "Mag-sign up ngayon",
	"gender.boy": "Boy",
	"gender.female": "Babae",
	"gender.girl": "Girl",
	"gender.male": "Lalake",
	"healthToolPNModal.back": "Back",
	"healthToolPNModal.findMore.chooseFav": "Choose from your favorite topics\n",
	"healthToolPNModal.finish": "Finish",
	"healthToolPNModal.heading": "Nhận bản tin miễn phí mỗi tuần?",
	"healthToolPNModal.mainForm.requireName": "Please enter your name",
	"healthToolPNModal.mainForm.tailorTopicsHeading": "These topics are tailored to your result",
	"healthToolPNModal.next": "Next",
	"healthToolPNModal.register": "Register",
	"healthToolPNModal.yourPre": "Your preferences",
	"healthTools.dueDateCalculator": "Due Date Calculator ",
	"healthTools.ovulationCalculator": "Ovulation Calculator",
	"healthtool.placeholder.age": "Your age",
	"home.calcWithApp": "Calculate on Hello Bacsi app",
	"home.menu.category.view": "Tingnan {category}",
	"home.navigator.app": "App",
	"home.navigator.downloadApp": "Download App",
	"home.navigator.menu.care.homeButton": "Booking Home",
	"home.navigator.menu.care.noDatas.cta": "Book a Doctor",
	"home.navigator.menu.care.noDatas.description": "HelloCare helps patients to find the right medical doctors and service treatment for their needs, in their vicinity.",
	"home.navigator.menu.care.noDatas.title": "Make an appointment with doctors easily",
	"home.navigator.menu.category.noDatas.cta": "Discover now",
	"home.navigator.menu.category.noDatas.description": "Nais ng Hello Doctor na maging iyong pinakapinagkakatiwalaang kaalyado para makagawa ng mas matalinong mga desisyon at mamuhay nang mas malusog at mas masaya.",
	"home.navigator.menu.category.noDatas.title": "Welcome to Hello Doctor",
	"home.navigator.menu.healthTools.noDatas.cta": "Discover more",
	"home.navigator.menu.healthTools.noDatas.description": "These easy-to-use health assessment tools will help you gauge vital parts of your overall health and wellness.",
	"home.navigator.menu.healthTools.noDatas.title": "Health Tools",
	"home.navigator.menu.lastestVideos": "Pinakabagong Shorts",
	"home.navigator.menu.podcasts": "Mga Podcast",
	"home.navigator.menu.shorts": "Shorts",
	"home.navigator.menu.spotlightEcom": "Categories",
	"home.navigator.menu.spotlightHospitals": "Popular Hospitals",
	"home.navigator.menu.spotlightTools": "Favorite Tools",
	"home.navigator.menu.spotlights": "Nakatuon ang Lahat",
	"home.navigator.menu.spotlights.seeAll": "Tingnan ang lahat ng may pagpokus",
	"home.navigator.menu.together.noPosts.cta": "Join Our Communities",
	"home.navigator.menu.together.noPosts.description": "Community is a safe space where you can connect with other members, comment on topics you care about, and receive trusted advice from medical experts on the health issues that matter most.",
	"home.navigator.menu.together.noPosts.title": "Welcome to Community",
	"home.navigator.menu.trendingPosts": "Highlight Posts",
	"home.navigator.menu.trendingPosts.seeMore": "Magpakita pa",
	"home.navigator.menu.videos": "Mga Bidyo",
	"home.navigator.menuItem.allCategories": "Tingnan ang lahat ng mga kategorya",
	"home.navigator.menuItem.allCommunities": "Tingnan ang lahat ng komunidad",
	"home.navigator.menuItem.allCommunitiesheadingTitle": "Find your communities",
	"home.navigator.menuItem.allHealthTools": "Tingnan ang lahat ng Health Tools",
	"home.navigator.menuItem.allSpecialties": "All specialties",
	"home.navigator.menuItem.allSpotlight": "Tingnan ang lahat ng may pagpokus",
	"home.navigator.menuItem.allVideos": "See All Videos",
	"home.navigator.menuItem.discover": "Matuklasan",
	"home.navigator.menuItem.healthCategories": "Mga Kategorya sa Kalusugan",
	"home.navigator.menuItem.healthTools": "Tool sa Kalusugan",
	"home.navigator.menuItem.healthToolsList": "Mga Health Tool",
	"home.navigator.menuItem.helloCare": "Pangangalaga",
	"home.navigator.menuItem.helloEcom": "eShop",
	"home.navigator.menuItem.helloTogether": "Komunidad",
	"home.navigator.menuItem.language": "Wika",
	"home.navigator.menuItem.new": "new",
	"home.navigator.menuItem.specialties": "Specialties",
	"home.navigator.menuItem.spotlights": "Nakatuon ang Lahat",
	"home.navigator.menuItem.video": "Video",
	"home.navigator.menuItem.videoCategories": "Video Categories",
	"home.search": "Maghanap {site}",
	"home.seeAll": "See All",
	"home.seeAllCategories": "See All Topics",
	"home.seeExpert": "Tingnan ang Buong Profile ng Eksperto",
	"home.seeHospital": "Tingnan ang Buong Profile ng Ospital",
	"home.seeMore": "See More",
	"home.seeMoreExperts": "See More Experts",
	"hospital.content.description": "Hospital Details",
	"inputComment.replyTo": "Reply to {name}",
	insert: insert,
	"label.latestPost": "Latest Post",
	"label.pinnedPost": "Pinned Post",
	"lead.empty.cancel": "Kansel",
	"lead.empty.submitAgain": "Isumite ulit",
	"lead.empty.title": "Oops, mukhang walang laman ang iyong impormasyon. Gusto mo bang isumite ulit ang impormasyon?",
	"leadgen.message.error.name_required": "Please enter your name",
	"leadgen.message.error.phone_invalid": "Please enter a valid phone number",
	loading: loading,
	"login.booking": "Magpakonsulta",
	"logout.popup.ask.mb": "Logout of Marry Baby",
	"logout.popup.ask1": "Maglo-log out sa Hello Doctor?",
	"logout.popup.ask2": "Sigurado ka bang maglo-log out sa Hello Doctor?",
	"logout.popup.button.cancel": "Kansel",
	"logout.popup.button.logout": "Mag-log out",
	"menu.care.searchBySpecialties": "Search by specialty",
	"morePopover.report": "Report",
	"morePopover.report.description": "Help us understand what’s happening with this post. How would you describe it?",
	"morePopover.report.falseNews": "False news",
	"morePopover.report.offensive": "Offensive",
	"morePopover.report.other": "Other",
	"morePopover.report.prohibited": "Prohibited content",
	"morePopover.report.scam": "Misleading or scam",
	"morePopover.report.sex": "Sexually inappropriate",
	"morePopover.report.spam": "Spam",
	"morePopover.report.title": "Report this post",
	"morePopover.report.violence": "Violence",
	"morePopover.reportSubmit.description": "We won’t tell them who reported it. Please check these details:",
	"morePopover.reportSubmit.title": "Submit report?",
	"morePopover.savePost": "Save post",
	"morePopover.share": "Share",
	"morePopover.shareOn": "Share on",
	"morePopover.turnOffNotifications": "Turn off notifications",
	"morePopover.turnOnNotifications": "Turn on notifications",
	"morePopover.unsavePost": "Remove Saved post",
	"navigation.loginJoin": "Login",
	"navigation.search.input.placeholder": "I-search",
	"navigation.signUp": "Sign up",
	"newsletter.error.minCotennt": "Please select at least 1 topic to continue this action",
	"newsletter.error.minTitle": "Minimum 1 topics reached",
	"newsletter.topic.title": "What health topics are you interested in?",
	"newsletter.welcome.description": "What name would you prefer to go by?",
	"notification.comment.blocked.message": "This comment contains banned words or phrases and won’t be published",
	"notification.comment.blocked.title": "Blocked comment",
	"notification.comment.premod": "Your comment needs to be reviewed.",
	"notification.comment.rejected": "Your comment contain words that are not allowed.",
	"notification.comment.reportFailed": "Failed!",
	"notification.comment.reportSuccess": "You have successfully reported a comment.",
	"notification.comment.somethingWrong": "Something went wrong.",
	"notification.comment.suspect.message": "This comment contains suspected words or phrases and won’t be published",
	"notification.comment.suspect.title": "Pending comment",
	"notification.comment.systemWithheld": "Your comment needs to be reviewed.",
	"notification.failure": "Something wrong. Try again later!",
	"notification.limitUrlDomain": "Cannot post link outside of Hello Health Group.",
	"notification.post.blocked.message": "This post contains banned words or phrases and won’t be published",
	"notification.post.blocked.title": "Blocked post",
	"notification.post.delete": "Post Deleted",
	"notification.post.suspect.message": "This post contains suspected words or phrases, and is placed for moderator review",
	"notification.post.suspect.title": "Pending post",
	"notification.success": "Success",
	"notification.suspend.message": "Your account has been suspended for violating our terms of service",
	"notification.urlWrongFormat": "Incorrect URL format",
	"onboarding.button.continue": "Magpatuloy",
	"onboarding.button.skip": "I-skip",
	"onboarding.errorMessage.invalidEmail": "Invalid ang email",
	"onboarding.errorMessage.minLength": "Please fill at least {length} characters",
	"onboarding.errorMessage.passNotMatch": "Hindi nagtugma ang mga password",
	"onboarding.errorMessage.passWithPattern": "Password must include upper and lowercase letters",
	"onboarding.errorMessage.requiredConfirmPassword": "Please fill your confirm password",
	"onboarding.errorMessage.requiredEmail": "Please fill your email",
	"onboarding.errorMessage.requiredName": "Please fill your name",
	"onboarding.errorMessage.requiredPassword": "Please fill your password",
	"onboarding.formEmail.description": "Ilagay ang iyong e-mail upang magpatuloy sa {site} Communities",
	"onboarding.formEmail.genderFemale": "Female",
	"onboarding.formEmail.genderMale": "Male",
	"onboarding.formEmail.heading": "Hayaan kaming mas makilala ka pa.",
	"onboarding.formEmail.yourBirthday": "Your birthday",
	"onboarding.formEmail.yourEmail": "Ang iyong email",
	"onboarding.formEmail.yourName": "Your name",
	"onboarding.label.fullName": "Full name",
	"onboarding.otpForm.description": "Nagsend kami ng One-Time Password (OTP) sa iyong {phone} number",
	"onboarding.otpForm.descriptionEmail": "We have sent a One-Time Password (OTP) to your email {email}",
	"onboarding.otpForm.error": "Maglagay ng valid na OTP",
	"onboarding.otpForm.heading": "I-enter ang iyong OTP",
	"onboarding.otpForm.notReceiveOTP": "Hindi nakatanggap ng OTP code?",
	"onboarding.otpForm.resendCode": "I-resend ang code",
	"onboarding.otpForm.resendCodeWithSeconds": "I-resend ang code {seconds}s",
	"onboarding.otpWhatsapps.description": "Isinend namin ang isang One-Time Password (OTP) sa iyong numero ng WhatsApp {phone}",
	"onboarding.otpWhatsapps.heading": "Pag-verify sa WhatsApp",
	"onboarding.similac.address.error": "Your address is required",
	"onboarding.similac.input.address": "Your address",
	"onboarding.similac.input.city": "Please select your city/province",
	"onboarding.similac.input.district": "Please select your district/town",
	"onboarding.similac.input.no": "Please enter your street name, building, house no.",
	"onboarding.similac.input.phone": "Your phone number",
	"onboarding.similac.input.ward": "Please select your ward/village",
	"onboarding.updatePassword.confirmPassword": "I-confirm ang password",
	"onboarding.updatePassword.description": "Siguraduhing ito ay 8 characters or higit pa",
	"onboarding.updatePassword.heading": "Malapit na! Kailangan lang ng password",
	"onboarding.updatePassword.password": "Password",
	"onboarding.updatePasswordResult.description": "You can now login to your Hellobacsi account with the new password.",
	"onboarding.updatePasswordResult.heading": "Password setup successful",
	"onboarding.updatePhone.description": "Magsesend kami ng One-Time Password sa iyong phone number",
	"onboarding.updatePhone.error": "Maglagay ng valid na phone number",
	"onboarding.updatePhone.heading": "Ang iyong phone number",
	"onboarding.updateWhatsapp.description": "Kailangang i-verify ng Whatsapp ang iyong numero ng telepono.",
	"onboarding.updateWhatsapp.submitLabel": "Magpatuloy gamit ang WhatsApp",
	"onboarding.welcomeScreen.content": "An open and welcoming environment where you can share, connect, and exchange support with other members to seek healthier and happier lives.",
	"onboarding.welcomeScreen.heading": "Welcome to Hello Bacsi Community",
	orCopyLink: orCopyLink,
	"ovulationPage.avoidPregnancy": "Iwasan ang pagbubuntis",
	"ovulationPage.conceive": "Sinusubukang magbuntis",
	"ovulationPage.cycleLength": "Haba ng Siklo",
	"ovulationPage.dayUnit": "mga araw",
	"ovulationPage.objectives": "Layunin",
	"ovulationPage.periodDuration": "Tagal ng Panahon",
	"ovulationPage.trackPeriod": "Subaybayan ang siklo ng regla",
	"placeholder.enterTitleHere": "Enter title here",
	"placeholder.enterUrlHere": "Enter URL here",
	"placeholder.enterUrlTextHere": "Enter URL Text here",
	"placeholder.newCmt": "Write a comment",
	"placeholder.newPost": "Start a new post",
	"pnBanner.both": "Both",
	"pnBanner.both.desc": "Welcome to the adventure of parenthood! Choose a tool that suit you.",
	"pnBanner.both.heading": "Experience our tools for parent!",
	"pnBanner.caclNow": "Calculate now",
	"pnBanner.checkNow": "Check now!",
	"pnBanner.dueDateTool.desc": "Plan ahead for the big day with a stress-free experience!",
	"pnBanner.dueDateTool.heading": "Try our Due Date Calculator",
	"pnBanner.hpv.desc": "Your response helps us craft recommendations specific to your family's needs.",
	"pnBanner.hpv.heading": "Keep your girl safe from HPV virus!",
	"pnBanner.parenting.desc": "Your response helps us craft recommendations specific to your family's needs. ",
	"pnBanner.parenting.heading": "What is the age range of your kids?",
	"pnBanner.pn.btnLabel": "Premium Newsletter",
	"pnBanner.pregnancy.desc": "Input this to ensure our recommendations suits your exciting new journey.",
	"pnBanner.pregnancy.heading": "Are you navigating the world of pregnancy?",
	"pnBanner.submit": "Submit",
	"pnBanner.teenager": "Teenager",
	"pnBanner.teenager.heading": "What is the gender of your kids?",
	"pnBanner.toddlers": "Toddlers",
	"pnBanner.vaccination.desc": "Keep your little one protected with customized vaccination schedules!",
	"pnBanner.vaccination.heading": "Try our Baby Vaccine Scheduler",
	"pnBanner.vaccine.btnLabel": "Baby Vaccine Scheduler",
	"pnModal.disclaimer": "Your first email digest is on its way. Get excited to dive into content that’s tailored specifically for you!",
	"pnTopicSection.maxSelectError.desc": "Remove at least 1 selected topic to continue this action",
	"pnTopicSection.maxSelectError.detail": "Choose maximum {max} topics ({maxTopic})",
	"pnTopicSection.maxSelectError.title": "Maximum {maxSelect} topics reached",
	"pnTopicSection.notFound": "Nothing found",
	"pnTopicSection.plsEnterFavTopics": "Please enter your favorite topics",
	"pnTopicSection.ppAlsoInterested": "People are also interested",
	"pnTopicSection.recentView": "Recently viewed",
	"pnTopicSection.trending": "Trending",
	"popup.allTopics": "All Topics",
	"popup.createPost.confirmCloseDescription": "If you discard now, you’ll lose this post",
	"popup.createPost.confirmCloseTitle": "Are you sure?",
	"popup.deleteComment.description": "Delete your comment cannot be undone",
	"popup.deleteComment.title": "Delete comment?",
	"popup.deletePost.accept": "Delete",
	"popup.deletePost.cancel": "Cancel",
	"popup.deletePost.description": "Delete your post cannot be undone",
	"popup.deletePost.title": "Delete post?",
	"popup.discardPost": "Discard post",
	"popup.discardPostEdit": "Discard changes",
	"popup.editPost": "Edit post",
	"popup.keepEditing": "Keep editing",
	"popup.startANewPost": "Start a new post",
	"post.commentCount": "{count} comments",
	"post.likesCount": "{count} likes",
	"post.remove.failed": "Nabigo ang pagtanggal",
	"post.remove.success": "Tinanggal ang naka-save na post",
	"post.save.failed": "Nabigo ang pag-save ng post",
	"post.save.success": "Naka-save ang post",
	"post.seeMore": "See more",
	"post.shareCount": "{count} shares",
	"pregnancy.week": "Linggo",
	"pregnancyTool.description": "Your Baby is as big as a <fruitName></fruitName>",
	"pregnancyTool.title": "Your weeks of pregnancy",
	"pregnancyTool.weightSuggested": "Weight suggested",
	"pregnancyWeightGain.havingTwins": "May kambal ka ba?",
	"pregnancyWeightGain.heading": "Nakuhang Timbang sa Pagbubuntis",
	"pregnancyWeightGain.heightInput": "Ano ang iyong taas?",
	"pregnancyWeightGain.weekInput": "Ilang linggo ka ng buntis?",
	"pregnancyWeightGain.weightBeforeInput": "Ano ang iyong timbang bago ka nagbuntis?",
	"pregnancyWeightGain.weightInput": "Ilan ngayon ang iyong ibinigat?",
	"pregnancyWeightGain.weightInput.desc": "(kg)",
	"pregnancyWeightGain.weightInput.error": "Mangyaring ilagay ang wastong timbang",
	"previewPhotos.title": "{name}'s Post",
	"profilePanel.anserwing.viewFull": "Tingnan ang buong sagot",
	"profilePanel.awards": "Mga Parangal at Akreditasyon",
	"profilePanel.createPost": "Gumawa ng post",
	"profilePanel.education": "Edukasyon",
	"profilePanel.emptyCareMess.content": "It looks like there are currently no questions for the doctor at this time. Thank you for being a part of our community.",
	"profilePanel.emptyPostMess.content": "Si {pangalan} ay hindi nakikibahagi sa anumang aktibidad kamakailan",
	"profilePanel.experience": "Karanasan",
	"profilePanel.joined": "Joined",
	"profilePanel.modal.heading": "Profile",
	"profilePanel.publishcation": "Mga Publikasyon",
	"profilePanel.publishedArticles": "Article na inilathala sa Hello Doctor",
	"profilePanel.question": "Tanong",
	"profilePanel.questionNotClear": "Hindi malinaw ang tanong",
	"profilePanel.skipQuestion.content": "Aalisin namin ang tanong na ito sa iyong listahan",
	"profilePanel.skipQuestion.heading": "Laktawan ang tanong na ito",
	"profilePanel.socialLinks": "Social Links",
	"profilePanel.tabs.care": "Pag-aaruga",
	"profilePanel.tabs.expertAnswer": "Pagsagot ng eksperto",
	"profilePanel.tabs.highlight": "Mga credential at highlight",
	"profilePanel.tabs.posts": "Mga post",
	"profilePanel.tabs.relevantArticles": "Mga kaugnay na article",
	"pwg.placeholder.height": "Taas (cm)",
	"pwg.placeholder.weight": "Timbang (kg)",
	"pwgForm.week": "linggo",
	"sensitiveMask.blur": "I-blur",
	"sensitiveMask.contentWarningDescription": "Babala: Ang susunod na larawan ay maaaring makabahala sa ibang makakakita. ",
	"sensitiveMask.contentWarningDescription.community": "Warning: The image may be disturbing.",
	"sensitiveMask.contentWarningMessage": "Maaring nakababahala ang mga imahe na ito...",
	"sensitiveMask.unblur": "Ipakita",
	"share.by": "Ibahagi sa pamamagitan ng",
	"share.copyLink": "O kopyahin ang link",
	"share.letsJoinCommunity": "Let's join {name} community!",
	"share.letsJoinTopic": "Let's join {name} topic!",
	"share.linkCopied": "Link Copied",
	"share.linkShared": "Link Shared Successfully",
	"share.title": "I-share",
	"shareContainer.title": "I-share ang resulta",
	"similac.thankYou.done": "Done",
	"ssov2.abTestingFlowB.description": "Sign up or log in with your email or social media account.",
	"ssov2.button.cancel": "Cancel",
	"ssov2.button.continue": "Continue",
	"ssov2.button.continueGoogle": "Continue with Google",
	"ssov2.button.continueSMS": "Continue with SMS",
	"ssov2.button.continueWhatsApp": "Continue with WhatsApp",
	"ssov2.button.continueZalo": "Continue with Zalo",
	"ssov2.button.exitNow": "I want to exit now",
	"ssov2.button.otp.sms": "Send OTP Code via SMS",
	"ssov2.button.otp.whatsapp": "Send OTP Code via WhatsApp",
	"ssov2.button.otp.zalo": "Send OTP Code via Zalo",
	"ssov2.button.save": "Save",
	"ssov2.button.setupLater": "Setup later",
	"ssov2.collectInfo.why": "Why We Need Your Information?",
	"ssov2.email.alreadyUsed": "Email này đã được sử dụng, vui lòng chọn Email khác.",
	"ssov2.email.button": "Verify Your Email",
	"ssov2.email.description": "Use your email to continue login or register",
	"ssov2.email.title": "Continue with email",
	"ssov2.error.api": "API error",
	"ssov2.error.api.000": "Some Things Went Wrong",
	"ssov2.error.api.001": "The email must be a valid email address.",
	"ssov2.error.api.002": "The email field is required.",
	"ssov2.error.api.003": "This member is not exist yet",
	"ssov2.error.api.004": "The email may not be greater than 255 characters.",
	"ssov2.error.api.005": "The phone number field is required.",
	"ssov2.error.api.006": "The phone number must be at least 9 characters.",
	"ssov2.error.api.007": "This phone number is already linked to your profile",
	"ssov2.error.api.008": "The otp code field is required.",
	"ssov2.error.api.009": "User don't update",
	"ssov2.error.api.010": "Verify OTP failed",
	"ssov2.error.api.011": "The name must be a string.",
	"ssov2.error.api.012": "The name may not be greater than 100 characters.",
	"ssov2.error.api.013": "The username must be a string.",
	"ssov2.error.api.014": "The username has already been taken.",
	"ssov2.error.api.015": "The username may not be greater than 20 characters.",
	"ssov2.error.api.016": "The birthday does not match the format Y-m-d.",
	"ssov2.error.api.017": "The avatar field is required.",
	"ssov2.error.api.018": "The avatar must be an image.",
	"ssov2.error.api.019": "The avatar must be a file of type: jpeg, jpg, png, gif.",
	"ssov2.error.api.020": "The avatar may not be greater than 10240 kilobytes.",
	"ssov2.error.api.021": "The confirm-password field is required.",
	"ssov2.error.api.022": "The confirm-password must be at least 8 characters.",
	"ssov2.error.api.023": "The confirm-password format is invalid.",
	"ssov2.error.api.024": "The confirm-password may not be greater than 50 characters.",
	"ssov2.error.api.025": "The new-password field is required.",
	"ssov2.error.api.026": "The new-password must be at least 8 characters.",
	"ssov2.error.api.027": "The new-password format is invalid.",
	"ssov2.error.api.028": "The new-password may not be greater than 50 characters.",
	"ssov2.error.api.029": "Your password doesn't match. Please try again.",
	"ssov2.error.api.030": "Your new password must be different from the current one",
	"ssov2.error.api.031": "The new password field is required.",
	"ssov2.error.api.032": "The confirm new password field is required.",
	"ssov2.error.api.033": "The new password and confirm new password must match.",
	"ssov2.error.api.034": "The confirm new password must be at least 8 characters.",
	"ssov2.error.api.035": "The new password must be at least 8 characters.",
	"ssov2.error.api.036": "The confirm new password may not be greater than 50 characters.",
	"ssov2.error.api.037": "The new password may not be greater than 50 characters.",
	"ssov2.error.api.038": "The current password is wrong!",
	"ssov2.error.api.039": "The password field is required.",
	"ssov2.error.api.040": "Token Signature could not be verified.",
	"ssov2.error.api.041": "Token has expired",
	"ssov2.error.api.042": "The refresh token field is required.",
	"ssov2.error.api.043": "The area code field is required.",
	"ssov2.error.api.044": "The email has already been taken.",
	"ssov2.error.api.045": "Verify Email OTP Code Fail",
	"ssov2.error.api.046": "The code field is required.",
	"ssov2.error.api.047": "The phone number has already been taken.",
	"ssov2.error.api.048": "The Phone is not match phone number that you registered",
	"ssov2.error.api.049": "User was exist",
	"ssov2.error.api.050": "The website id field is required.",
	"ssov2.error.api.051": "The name field is required.",
	"ssov2.error.api.052": "The birthday field is required.",
	"ssov2.error.api.053": "The gender field is required.",
	"ssov2.error.api.054": "The provider field is required.",
	"ssov2.error.api.055": "The token field is required.",
	"ssov2.error.api.056": "Code has been sent to your email",
	"ssov2.error.api.057": "The email does not exist.",
	"ssov2.error.api.058": "You are verifying a phone number that is not yours",
	"ssov2.error.api.059": "The selected phone number is invalid.",
	"ssov2.error.api.060": "Phone does not member",
	"ssov2.error.api.061": "This phone number is already linked to your profile",
	"ssov2.error.api.062": "Error ZNS with missing msg_id",
	"ssov2.error.api.063": "OTP verify missing",
	"ssov2.error.api.064": "The expire at must be a date after 5 mins.",
	"ssov2.error.api.065": "The selected code is invalid.",
	"ssov2.error.api.066": "Error when update ZNS tracking",
	"ssov2.error.api.067": "Sent Zalo OTP failed",
	"ssov2.error.api.068": "The expire at must be a date after 10 mins.",
	"ssov2.error.api.069": "The code must be at least 6 characters.",
	"ssov2.error.api.070": "The code may not be greater than 10 characters.",
	"ssov2.error.api.071": "You’ve reached the limit of 3 verification attempts in 1 hour. Please wait and try again later.",
	"ssov2.error.api.072": "You’ve reached the limit of 5 verification attempts today. Please try again tomorrow.",
	"ssov2.error.api.073": "The password must be at least 8 characters.",
	"ssov2.error.api.074": "The password format is invalid.",
	"ssov2.error.api.075": "The confirm-password format is invalid.",
	"ssov2.error.api.076": "The password must contain at least one number.",
	"ssov2.error.api.077": "The confirm-password must contain at least one number.",
	"ssov2.error.api.078": "The email was exist",
	"ssov2.error.api.079": "Too many messages",
	"ssov2.error.api.080": "The selected otp code is invalid",
	"ssov2.error.api.082": "The password must contain at least one uppercase and one lowercase letter.",
	"ssov2.error.api.083": "Sent Whatsapp OTP failed",
	"ssov2.error.facebookLogin": "Facebook login failed",
	"ssov2.error.googleLogin": "Error login with Google",
	"ssov2.first.country.code": "Country Code",
	"ssov2.first.description": "Continue with your phone number, email or your socials to log in or sign up.",
	"ssov2.first.noAccountOrPass": "You have no account or need to setup password, please continue register",
	"ssov2.first.search.country.all": "All Countries",
	"ssov2.first.search.country.placeholder": "Search country/region",
	"ssov2.first.search.country.selected": "Current selection",
	"ssov2.first.title.login": "Log In",
	"ssov2.first.title.signup": "Sign Up",
	"ssov2.orContinueWith": "Or continue with",
	"ssov2.otp.email.description": "Enter the 6-digit OTP sent to your email <b>{email}</b>. OTP code will expire in <b>10 mins</b>",
	"ssov2.otp.email.title": "Verify Email",
	"ssov2.otp.phone.description": "Enter the 6-digit OTP sent to the phone number <b>{phone}</b> via <b>{method}</b>. OTP code will expire in <b>10 mins</b>",
	"ssov2.otp.phone.title": "Verify Phone Number",
	"ssov2.otp.resendQuestion": "Didn’t receive the code?",
	"ssov2.otp.resendText": "Resend ({count}s)",
	"ssov2.otp.sendVia": "Send OTP Code via {method}",
	"ssov2.password.description": "Đăng nhập bằng mật khẩu của bạn.",
	"ssov2.password.forgotPassword": "Forgot Password?",
	"ssov2.password.reset": "Reset",
	"ssov2.password.signIn": "Sign In",
	"ssov2.password.title1": "Welcome back!",
	"ssov2.password.title2": "Enter your password",
	"ssov2.passwordForgotSetup.description": "Set up your login password and other details to complete the registration process.",
	"ssov2.passwordForgotSetup.field.password.atLeast8Chars": "At least 8 characters.",
	"ssov2.passwordForgotSetup.field.password.atLeastOneUpper": "At least one uppercase letter, one lowercase letter, and one number.",
	"ssov2.passwordForgotSetup.field.password.label": "Password",
	"ssov2.passwordForgotSetup.field.password.placeholder": "Input your password",
	"ssov2.passwordForgotSetup.field.passwordConfirm.label": "Confirm Password",
	"ssov2.passwordForgotSetup.field.passwordConfirm.placeholder": "Confirm Password",
	"ssov2.passwordForgotSetup.title": "Setup your password",
	"ssov2.phone.alreadyUsed": "Phone number is already used, please use another phone number",
	"ssov2.phoneVerify.description": "Please provide additional information to complete the account registration process.",
	"ssov2.phoneVerify.title": "Verify Phone Number",
	"ssov2.policyText": "By signing up, I confirm that I have read, understand and agree to the {privacy} and the {terms} of Hello Health Group. I agree for Hello Health Group to collect, store, use, disclose, and process my information in accordance with Hello Health Group’s Privacy Policy. Furthermore, I agree for Hello Health Group to use my information to send me promotional information (including by direct mail, email, telephone, and text message) or otherwise contact me about products, services, programs or other topics that Hello Health Group think may interest me; and Hello Health Group can share my information to its partners and clients in order for them to provide more helpful services and promotional information.",
	"ssov2.policyText.community": "By signing up, I confirm that I have read, understand and agree to the {privacy} and the {terms} of Hello Health Group. I agree to join the community of HelloDoctor, and I agree for Hello Health Group to collect, store, use, disclose, and process my information in accordance with Hello Health Group’s Privacy Policy. Furthermore, I agree for Hello Health Group to use my information to send me promotional information (including by direct mail, email, telephone, and text message) or otherwise contact me about products, services, programs or other topics that Hello Health Group think may interest me; and Hello Health Group can share my information to its partners and clients in order for them to provide more helpful services and promotional information.",
	"ssov2.policyText.privacy": "Privacy Policy",
	"ssov2.policyText.terms": "Terms of Service",
	"ssov2.popup.close.description": "You’re just a step away from completing your account setup. Do you really want to leave?",
	"ssov2.popup.close.title": "Are you sure you want to exit?",
	"ssov2.resetPassword.description": "Please provide the phone number you used to create your account.",
	"ssov2.resetPassword.title": "Reset password",
	"ssov2.setup.button.createAccount": "Create new account",
	"ssov2.setup.button.veriyPhone": "Verify Phone Number",
	"ssov2.setup.description": "Please provide additional information to complete the account registration process.",
	"ssov2.setup.field.dob.label": "Birthday",
	"ssov2.setup.field.dob.placeholder": "Enter your birthday",
	"ssov2.setup.field.email.label": "Email",
	"ssov2.setup.field.gender.female": "Female",
	"ssov2.setup.field.gender.label": "Gender",
	"ssov2.setup.field.gender.male": "Male",
	"ssov2.setup.field.name.label": "Name",
	"ssov2.setup.field.name.placeholder": "Enter your name",
	"ssov2.setup.field.otp.label": "Receive OTP Via",
	"ssov2.setup.field.phone.label": "Phone number",
	"ssov2.setup.title": "Almost done!",
	"ssov2.updateEmail.button": "Verify Your Email",
	"ssov2.updateEmail.description": "Please update and verify your email to continue using our services.",
	"ssov2.updateEmail.title": "Update Your Email",
	"ssov2.useOtherMethod.email": "This account has not enabled login with an email. Please choose another login method.",
	"ssov2.useOtherMethod.phone": "This account has not enabled login with a phone number. Please choose another login method.",
	"ssov2.validate.confirmPassword.match": "Passwords must match",
	"ssov2.validate.confirmPassword.required": "Confirm password is required",
	"ssov2.validate.dob.required": "Date of birth is required",
	"ssov2.validate.email.invalid": "Invalid email",
	"ssov2.validate.email.required": "Email is required",
	"ssov2.validate.gender.oneOf": "Gender must be male or female",
	"ssov2.validate.gender.required": "Gender is required",
	"ssov2.validate.name.required": "Name is required",
	"ssov2.validate.otp.required": "OTP method is required",
	"ssov2.validate.password.required": "Password is required",
	"ssov2.validate.phone.required": "Phone number is required",
	submit: submit,
	"switchBtn.no": "Hindi",
	"switchBtn.yes": "Oo",
	"tab.about": "About",
	"tab.discussion": "Discussions",
	"tab.topic": "Topics",
	"tagTopic.moreTopics": "{number} more topics",
	"targetHearRate.heading": "Target Heart Rate Calculator",
	"targetHeartRate.aerobicZone.note": "Aerobic Zone (katamtamang ehersisyo/ isports 3-5 na araw/ linggo)",
	"targetHeartRate.aerobicZone.title": "Aerobic Zone",
	"targetHeartRate.ageInput": "Ano ang petsa ng iyong kaarawan?",
	"targetHeartRate.ageInput.desc": "(mga taon)",
	"targetHeartRate.ageInput.error": "Ilagay ang iyong kasalukuyang edad",
	"targetHeartRate.heartRateInput": "Ano ang iyong resting heart rate?",
	"targetHeartRate.heartRateInput.desc": "(bpm)",
	"targetHeartRate.heartRateInput.error": "Ilagay ang iyong aktwal na resting heart rate",
	"targetHeartRate.lowIntensity.note": "Mababang intesidad (kaunti o walang ehersisyo)",
	"targetHeartRate.lowIntensity.title": "Mababang intesidad",
	"targetHeartRate.maximumIntensity.note": "Pinakamataas na Intensity (napakahirap na ehersisyo/ isports o X2 na pagsasanay)",
	"targetHeartRate.maximumIntensity.title": "Pinakamataas na Intensity",
	"targetHeartRate.moderateIntensity.note": "Katamtamang intesidad (ehersisyo/ isport 1-3 na araw/linggo)",
	"targetHeartRate.moderateIntensity.title": "Katamtamang intesidad",
	"targetHeartRate.optional": "(opsyonal)",
	"targetHeartRate.selectActive": "Gaano ka kaaktibo sa araw-araw?",
	"targetHeartRate.vigorousIntensity.note": "Masiglang intensity (mahirap na ehersisyo/ isports na 6-7 araw/linggo)",
	"targetHeartRate.vigorousIntensity.title": "Masiglang intensity",
	"tool.askChecking": "I’m checking for other",
	"tool.selectPerson": "Ano ang iyong tinitingnan?",
	"tool.selectPerson.other": "Iba pa",
	"tool.selectPerson.yourSelf": "Sarili",
	"toolPage.toolReviewer": "Narebyung medical ni {expert_name} sa {date}",
	"tools.checkYourKidsInput.label": "Ikaw ba ay nagche-check para sa iyong anak?",
	"tools.checkYrs": "Ikaw ba ang nagche-check para sa sarili mo?",
	"tools.heading.on": "sa",
	"tools.heartRateRangeErr": "Pakilagay ang halaga sa pagitan ng {min} - {max} bpm",
	"tools.inputPlaceholder": "Halimbawa: {content}",
	"tools.requiredErrorMess.age": "Mangyaring ilagay ang wastong edad",
	"tools.requiredErrorMess.gender": "Paki-enter ang kasarian",
	"tools.selectBabyGender": "Ano ang kasarian ng iyong sanggol?",
	"tools.selectGender": "Ano ang iyong  kasarian?",
	"tools.yearsOld": "taong gulang",
	"updatePost.popup.success": "The post has been updated successfully.",
	"userProfile.nav.card.eCom": "eShop",
	"userProfile.nav.card.ecom.DeliveryAddress": "Manage addresses",
	"userProfile.nav.card.ecom.manageOrders": "Manage orders",
	"userProfile.nav.card.ecom.voucher": "Voucher",
	"userProfile.nav.card.myBooking": "My Booking",
	"userProfile.nav.card.myCommunity": "My Community",
	"userProfile.nav.card.myFamily": "Family Profiles",
	"userProfile.nav.card.myHealth": "My Health",
	"userProfile.nav.card.mySaved": "Saved",
	"userProfile.nav.header.count.comments": "Comments",
	"userProfile.nav.header.count.posts": "Posts",
	"userProfile.nav.header.count.tools": "Tools",
	"userProfile.nav.header.points": "Points",
	"userProfile.nav.header.viewProfile": "View My Profile",
	"userProfile.nav.menu.accountSettings": "Account Settings",
	"userProfile.nav.menu.dataPrivacy": "Pribadong Datos",
	"userProfile.nav.menu.disableAccount": "Disable Account",
	"userProfile.nav.menu.help": "Help",
	"userProfile.nav.menu.logout": "Log out",
	"userProfile.nav.menu.password": "Password",
	"userProfile.userRank.ambassador": "Ambassador",
	"userProfile.userRank.doctor": "Doctor",
	"userProfile.userRank.expert": "Expert",
	"userProfile.userRank.influencer": "Influencer",
	"userProfile.userRank.member": "Member",
	"validation.error.requiredAgeGroup": "Your child is not in the required age group",
	"validation.error.requiredField": "Kinakailangan ang field na ito",
	"verifyBotAnswer.confirmEndorse.accept": "Yes, endorse",
	"verifyBotAnswer.confirmEndorse.cancel": "No, cancel",
	"verifyBotAnswer.confirmEndorse.description": "Thank you for endorsing the answer",
	"verifyBotAnswer.confirmEndorse.heading": "Endorse this answer"
};

export { character, copied, copy, tlTranslations as default, insert, loading, orCopyLink, submit };
